import { SET_BREADCRUMBS_FACET } from '../../mutation-types';

export default {
    [SET_BREADCRUMBS_FACET](state, { facet }) {
        state.facet = facet;
    },
};
